import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderInfo } from '../../model/loader/loader-info';
import { LoaderTypeEnum } from '../../model/loader/loader-type';
import { LoaderService } from '../../service/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent implements OnInit, OnDestroy {
  loaderSubscribe$: Subscription;
  loaderInfo: LoaderInfo;
  loaderTypes = LoaderTypeEnum;

  constructor(private loaderService: LoaderService) {}

  ngOnInit(): void {
    this.loaderSubscribe$ = this.loaderService
      .isLoading()
      .subscribe((loaderInfo) => {
        this.loaderInfo = loaderInfo;
      });
  }

  ngOnDestroy(): void {
    this.loaderSubscribe$.unsubscribe();
  }
}
